import { Activity, Clock3, MessageSquareText, Target, UserPlus, Users } from 'lucide-react';

const formatDuration = (seconds) => {
  if (!seconds) return '0m';
  return `${Math.floor(seconds / 60)}m ${seconds % 60}s`;
};

export const AdminKpiGrid = ({ kpis }) => {
  const metrics = [
    { id: 'active-users', label: 'Active users', value: kpis.active_users, detail: `${kpis.new_users} new`, icon: Users },
    { id: 'sessions', label: 'Practice sessions', value: kpis.sessions, detail: `${kpis.completed_sessions} completed`, icon: MessageSquareText },
    { id: 'completion', label: 'Completion rate', value: `${kpis.completion_rate}%`, detail: 'Started to completed', icon: Target },
    { id: 'leads', label: 'Leads captured', value: kpis.leads, detail: `${kpis.total_users} total accounts`, icon: UserPlus },
    { id: 'score', label: 'Average score', value: kpis.average_score, detail: 'Communication quality', icon: Activity },
    { id: 'duration', label: 'Average session', value: formatDuration(kpis.average_duration_seconds), detail: `${kpis.average_turns} turns`, icon: Clock3 },
  ];
  return (
    <section className="grid gap-px overflow-hidden border border-[#DDD7CD] bg-[#DDD7CD] sm:grid-cols-2 xl:grid-cols-6" data-testid="admin-kpi-grid">
      {metrics.map(({ id, label, value, detail, icon: Icon }, index) => (
        <div className="min-h-40 bg-white p-5 animate-message-in" style={{ animationDelay: `${index * 0.04}s` }} key={id} data-testid={`admin-kpi-${id}`}>
          <div className="flex items-center justify-between"><p className="text-[10px] font-semibold uppercase text-[#8A8D8A]">{label}</p><Icon className="h-4 w-4 text-[#2C5545]" strokeWidth={1.5} /></div>
          <p className="mt-8 font-serif text-4xl text-[#1A1C18]">{value}</p>
          <p className="mt-2 text-xs text-[#6B6E69]">{detail}</p>
        </div>
      ))}
    </section>
  );
};
